import { shallowEqual, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { STUDIO_BASE_URL } from '@constants';
import Icon, { IconType } from 'components/Icon';
import Logo from 'components/Widget/Logo';
import ColorButton from 'components/Widget/Button/ColorButton';
import { logout } from 'utils';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

// Full-screen block shown when the environment's allowlist excludes the
// signed-in account. The copy deliberately says nothing about what this
// environment is for — the user only needs to know their account and work
// live on the production site. Guests never see it: they have no email to
// check and can only reach publicly shared resources.
const RestrictedGate = () => {
	//----------------------------------------------------------------------
	// HOOKS
	//----------------------------------------------------------------------

	const theme = useTheme();
	const { authUser } = useSelector(
		(r: RootReducer) => ({
			authUser: r.mode.authUser,
		}),
		shallowEqual
	);

	//----------------------------------------------------------------------
	// RENDERING
	//----------------------------------------------------------------------

	if (!authUser || authUser.id === 'guest' || authUser.accessAllowed) return null;

	return (
		<S.Base>
			<S.Card>
				<S.Brand>
					<Icon type={IconType.MOONCHILD} width={32} height={32} color={theme.gray[1000]} />
					<Logo height={20} />
				</S.Brand>
				<S.Heading>Oops — wrong door</S.Heading>
				<S.Body>
					{"You've landed on a private space the Moonchild team uses. " +
						"Everything you're looking for is waiting on the main site."}
				</S.Body>
				<S.CtaWrap>
					<ColorButton
						label="Take me to Moonchild"
						color="blue"
						onClick={() => (window.location.href = STUDIO_BASE_URL)}
					/>
				</S.CtaWrap>
				<S.Footer>
					Signed in as {authUser.email} ·{' '}
					<S.FooterLink type="button" onClick={() => logout()}>
						Sign out
					</S.FooterLink>
				</S.Footer>
			</S.Card>
		</S.Base>
	);
};

export default RestrictedGate;
